import { StyledTabs } from 'components/TabsPaneStyles'
import About from 'modules/Roles/Partials/ViewCollegeDetails/Partials/CollegeInfo/About'
import { FlexWrap } from 'modules/Roles/Partials/ViewCollegeDetails/Partials/Styles/style'
import CandidatesTable from 'modules/Roles/ViewRole/CandidatesTable'
import React from 'react'
import { useParams } from 'react-router-dom'
import { COLORS } from 'theme'

const CollegeInfo = ({
  setViewDrawer,
  getAppliedCandidateList,
  getInstitutesList,
  institutesList,
  setInstitutesList,
  degreeListData,
  getCandidateDetails,
  instituteCampusDetails,
  instituteDetails,
  getDegreesBasedOnRoles,
  roleBasedDegreeList,
  draftData,
  resumeBulkDownload,
  isAllSelected,
  setIsAllSelected,
}) => {
  const params = useParams()

  return (
    <FlexWrap padding={'0'} column>
      <StyledTabs
        width="100%"
        defaultActiveKey="1"
        textColor={COLORS.PRIMARY}
        headerpadding={'0 25px'}
        bgcolor={'none'}
        items={[
          {
            label: `About`,
            key: '1',
            children: (
              <About
                instituteCampusDetails={instituteCampusDetails}
                instituteDetails={instituteDetails}
                draftData={draftData}
              />
            ),
          },
          {
            label: `Applied Candidates`,
            key: '2',
            children: (
              <CandidatesTable
                draftData={draftData}
                instituteId={params?.instituteCampusId}
                viewRoleDetails={true}
                setViewDrawer={setViewDrawer}
                getAppliedCandidateList={getAppliedCandidateList}
                getInstitutesList={getInstitutesList}
                institutesList={institutesList}
                setInstitutesList={setInstitutesList}
                roleBasedDegreeList={roleBasedDegreeList}
                getCandidateDetails={getCandidateDetails}
                getDegreesBasedOnRoles={getDegreesBasedOnRoles}
                resumeBulkDownload={resumeBulkDownload}
                isAllSelected={isAllSelected}
                setIsAllSelected={setIsAllSelected}
              />
            ),
          },
        ]}
      />
    </FlexWrap>
  )
}

export default CollegeInfo
